export const SIZES = {
  PRODUCT_CARD_SMALL: 220,
  PRODUCT_CARD_LARGE: 272,
  MODAL_WIDTH_DESKTOP: 825,
  MIN_MODAL_HEIGHT_DESKTOP: 620,
  MAX_MODAL_HEIGHT_DESKTOP: 635,
  MAX_PRODUCT_DESCRIPTION_WIDTH: 280,
};

export const LOADING_STATE = {
  INSET_DESKTOP: 300,
  INSET_MOBILE: 400,
  WIDTH_MOBILE: 100,
  HEIGHT: 200,
};

export const CLOSE_MODAL_TYPES = {
  CLICK: 'click',
  BUTTON: 'button',
};

export const CLOSE_MODAL_LOCATIONS = {
  CONTINUE_SHOPPING: 'Close Modal - Continue Shopping',
  VIEW_CART_AND_CHECKOUT: 'Close Modal - View Cart & Checkout',
  EXIT_MODAL: 'Close Modal - Exit Modal',
};
